import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';


@customElement('complete-questionaire-popup')
export class CompleteQuestionairePopup extends DeviceAwareComponent {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 66%;
          height: 30rem;
        background-image: url(./assets/proposal-after-paid.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-bottom: 1rem;
        margin-top: 0;
      }

      .title {
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
      }

      .message {
        padding-inline: 2rem;
        color: var(--c-select);
      }

      .bold {
        font-weight: var(--font-weight-emphasize);
      }
    `,
    ];
  };

  render() {
    return html`
      <h1 class="title">${t('T_Complete_Title')}</h1>
      <h2 class="message">${t('T_Complete_Text')}</h2>
      <h2 class="message bold">${t('T_Complete_Text2')}</h2>
      <div id="art"></div>
    `;
  }
}
